<template>
  <div class="container page sex-page">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-radio-group v-model="radio">
        <div class="sex-card">
          <div class="sex-item van-hairline--bottom" @click="chooseSex('1')">
            <span class="sex-label">{{ $t('setting.man') }}</span>
            <van-radio name="1" icon-size="18px" checked-color="#8056e3" />
          </div>
          <div class="sex-item" @click="chooseSex('2')">
            <span class="sex-label">{{ $t('setting.female') }}</span>
            <van-radio name="2" icon-size="18px" checked-color="#8056e3" />
          </div>
        </div>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import { getStoredLang } from '../../utils/lang'
export default {
  data() {
    return {
      radio: '',
      userInfo: {}
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    chooseSex(sex) {
      if (this.radio === sex) return
      this.$http({
        method: 'post',
        data: { sex },
        url: 'user_set_sex'
      }).then(res => {
        if (res.code === 200) {
          this.radio = sex
          this.getUserInfo()
          this.$toast(res.msg)
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
        headers: { lang: getStoredLang() }
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
          this.radio = String(res.data.sex || '')
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.sex-page {
  background: #f2f2f5;
}

.main-content {
  padding: 0.75rem;
  overflow: visible;
}

.sex-card {
  background: #fff;
  border-radius: 0.625rem;
  overflow: hidden;
  box-shadow: 0 0.13333rem 0.2rem rgba(0, 0, 0, 0.04);
}

.sex-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 3.25rem;
  padding: 0.875rem 1rem;
  box-sizing: border-box;
}

.sex-label {
  font-size: 0.9375rem;
  color: #333;
}

::v-deep .van-radio {
  overflow: visible;
}

::v-deep .van-radio__icon {
  font-size: 1.125rem;
}

::v-deep .van-radio__icon .van-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .van-radio__label {
  display: none;
}
</style>
